import React from 'react';

function SampleCollectionLabLogin() {
    return (
        <div>
        <h1>Sample Collection Lab Login</h1>
        {/* Contenido de la página */}
        </div>
    );
}

export default SampleCollectionLabLogin;